import React from "react";
import * as S from "./index-styled";
import PT from "prop-types";
import BasketIcon from "_c/icon/Basket";
import { Link } from "react-router-dom";
import { LinkGenerator } from "@/utils/LinkGenerator";

const Basket = ({ amount, master, openBookingModal, t }) => {
  return (
    <S.Sect>
      <S.Title>{t("client_profile:blocks.cart")}</S.Title>
      <S.BasketWrap>
        <S.BasketIconWrap>
          {amount === 0 && <BasketIcon color="var(--color-primary)" />}
          {amount > 0 && (
            <Link
              title={t("common:master")}
              to={LinkGenerator.masterProfile(master)}
            >
              <BasketIcon color="var(--color-primary)" />
            </Link>
          )}
          <S.BasketCount>{amount}</S.BasketCount>
        </S.BasketIconWrap>
        <S.BasketServicesWrap />
        {amount > 0 && (
          <S.PayButton secondary large onClick={() => openBookingModal()}>
            {t("common:book_action")}
          </S.PayButton>
        )}
      </S.BasketWrap>
    </S.Sect>
  );
};
Basket.propTypes = {
  amount: PT.number,
  master: PT.string,

  openBookingModal: PT.func.isRequired,
  t: PT.func.isRequired,
};
export default Basket;
